import { render, staticRenderFns } from "./LeaderSelectProject.vue?vue&type=template&id=40595fa3"
import script from "./LeaderSelectProject.vue?vue&type=script&lang=js"
export * from "./LeaderSelectProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports